import ajaxPromises from '../../../common/js/AjaxPromises';
import joinUrl from '@ogury/url-join';
import CONFIG from '../../../common/js/config';
import { generateUrlWithRegion } from '../../../common/js/url-utils';

interface AdDeliveryOptions {
  context?: {
    log_mode?: boolean | null;
    region?: string;
    impressionId?: string;
    adUnitId?: string;
    campaignId?: string;
  };
}

export function logDiagnostic(
  body: Record<string, any>,
  adDeliveryOptions: AdDeliveryOptions
): Promise<string | void> {
  if (
    !adDeliveryOptions ||
    !adDeliveryOptions.context ||
    [false, undefined, null].indexOf(
      adDeliveryOptions.context.log_mode as any
    ) > -1
  ) {
    return Promise.resolve();
  }

  const logUrl = joinUrl(
    generateUrlWithRegion(CONFIG.MS_ADS_URL, adDeliveryOptions.context.region),
    '/log'
  );

  const queryParams = [
    `imp=${adDeliveryOptions.context.impressionId}`,
    `auid=${adDeliveryOptions.context.adUnitId}`,
    `oc_id=${adDeliveryOptions.context.campaignId}`
  ];

  return ajaxPromises.postJson(`${logUrl}?${queryParams.join('&')}`, body);
}
